module.exports = __webpack_public_path__ + "static/Illustration_Doctor-09e8f14700bb7fbbdb8a4e432f842ebc.svg";